<template>
  <el-tooltip class="info-tooltip"
              v-show="showTooltip"
              effect="dark"
              placement="right">
    <div slot="content">
<!--      Legend for tooltip column, displayed when no row prop is provided (for header)  -->
      <div v-if="!row" class="d-flex flex-column justify-content-between">
        <div>
          A tooltip icon will be shown when there is extra information about the inspection.<br />
        </div>
        <div class="d-flex align-items-center justify-content-center my-2">
          <div class="has-on-hold-client p-2 mr-2"></div>
          <div>
            This inspection belongs to a Job for an On-Hold client.
          </div>
        </div>
        <div class="d-flex align-items-center justify-content-center my-2">
          <div class="manually-assigned-inspector p-2 mr-2"></div>
          <div>
            This inspection assigned is saved in PTRAC (either before routing or during this session).
          </div>
        </div>
        <div class="d-flex align-items-center justify-content-center my-2">
          <div class="unavailable-manually-assigned-inspector p-2 mr-2"></div>
          <div class="inline-block">
            This inspection was assigned before auto-routing, but the assigned inspector is <strong>unavailable</strong>
          </div>
        </div>
        <div class="d-flex align-items-center justify-content-center my-2">
          <div class="manually-reassigned p-2 mr-2"></div>
          <div>
            This inspection was manually reassigned in this session and has not been saved in PTRAC.
          </div>
        </div>
        <div class="d-flex align-items-center justify-content-center my-2">
          <div class="reinspection p-2 mr-2"></div>
          <div>
            This inspection is a reinspection. Information about previous inspector will be shown.
          </div>
        </div>
        <div v-if="isSimulation">
          <p>In Simulation mode, it will also show information about the AI scoring for the assignment:</p>
          <ul>
            <li>
              Eligibility: This score, normalized to 1000pts, is calculated from the number of this Inspection Type that this
              Inspector has completed, weighted for recency. (ie. if the most an inspector did was 10 last week,
              then an inspector who did 5 last week will have an eligibility score of 500, while the other inspector will have 1000.
            </li>
            <br />
            <li>
              Location Score: This score, normalized to 1000pts, is calculated based on how many inspections this inspector has
              performed in the same City/Community/StreetName/StreetNumber, weighted for recency.
            </li>
          </ul>
        </div>
      </div>
      <div v-else>
        <p v-if="row.hasOnHoldClient">
         The client for this job is currently On Hold
        </p>
        <p v-if="row.unavailableManuallyAssignedInspector">
          <strong>Manually Assigned Inspector Unavailable:</strong><br />
          {{ row.unavailableManuallyAssignedInspector.name }}
        </p>
        <p v-if="row.reinspection">
          <strong>REINSPECTION</strong><br />
          Previous Inspector: {{ row.mostRecentAvailableInspectorForReinspection
            ? row.mostRecentAvailableInspectorForReinspection.name
            : "None Available" }}
        </p>
        <p v-if="row.manuallyReassigned">
          <strong>Manually reassigned this session and not yet saved in PTRAC </strong>
        </p>
        <p v-else-if="row.manuallyAssignedInspector">
          <strong>Assignment saved in PTRAC</strong>
        </p>
        <p v-if="isSimulation && row.assignedInspector && row.assignedInspector.id !== constants.INSPECTOR_ROUTING.UNASSIGNED.VALUE">
          Eligibility Score: {{ row.eligibilityScore }}<br>
          Location Score: {{ row.locationScore }}<br>
        </p>
      </div>
    </div>

    <img class="icon-info w-100" src="static/img/icon-info.png" alt="icon-info"/>

  </el-tooltip>
</template>

<script>
import {sync} from 'vuex-pathify'
import Constants from '@/utilities/constants'

export default {
    props: ['row'],
    computed: {
      //TODO: should be able to do this with mapGetters, but the nested prop is giving me grief)
      isSimulation: sync('inspectorRouting/solverParams@isSimulation'),

      showTooltip() {
        // always show header tooltip with info
        if (!this.row) {
          return true
        }

        if (this.isSimulation && this.row.assignedInspector && this.row.assignedInspector.id !== Constants.INSPECTOR_ROUTING.UNASSIGNED.VALUE) {
          return true
        } else if (this.row.unavailableManuallyAssignedInspector || this.row.reinspection || this.row.manuallyAssignedInspector || this.row.manuallyReassigned || this.row.hasOnHoldClient) {
          return true
        } else {
          return false
        }
      }
    },
    data() {
      return {
        constants: Constants
      }
    }
  }
</script>

<style scoped>
>>>.manually-assigned-inspector {
  background-image:
    radial-gradient(
      circle closest-side,
      white 50%,
      #ffd99b
    )!important;;
  background-color: #ffd99b!important;
}

>>>.unavailable-manually-assigned-inspector {
  background-image:
    radial-gradient(
      circle closest-side,
      white 50%,
      #ff6666
    )!important;
  background-color: #ff6666!important;
}

>>>.manually-reassigned {
  background-image:
    radial-gradient(
      circle closest-side,
      white 50%,
      #87CB16
    )!important;;
  background-color: #87CB16!important;
}

>>>.reinspection {
  background-image:
    radial-gradient(
      circle closest-side,
      white 50%,
      #5cd8ff
    )!important;
  background-color: #5cd8ff!important;
}

>>>.has-on-hold-client {
  background-image:
    radial-gradient(
      circle closest-side,
      white 50%,
      #cc2222
    )!important;
  background-color: #cc2222!important;
}
</style>
